import { takeEvery, call, put } from 'redux-saga/effects'

import {
  updateExpiredExtendTrial,
  errorExpiredExtendTrial,
  EXPIRED_EXTEND_TRIAL_GET,
} from 'actions/expired'
import { updateUserData } from 'actions/general'
import { logInteraction } from 'util/log-interaction'

const parseResponseText = responseText => {
  try {
    return JSON.parse(responseText)
  } catch (e) {
    return {
      msg:
        'Oh snap! Something went wrong, please contact support: https://help.victorops.com/knowledge-base/how-to-contact-splunk-on-call-support/',
    }
  }
}

function _getExpiredExtendTrial({ fetch }, logError) {
  return function*(action) {
    try {
      logInteraction('expired')
      const orgslug = action.payload.orgslug

      const accountEndpoint = `/billing/${orgslug}/extend-trial`

      const expiredResult = yield call(fetch, accountEndpoint)

      yield put(
        updateExpiredExtendTrial({
          data: expiredResult,
        })
      )
      yield put(
        updateUserData({
          orgslug,
          portalUrl: expiredResult.returnTo,
        })
      )
    } catch (err) {
      yield call(logError, err)

      const data =
        err.status >= 400 && err.responseText
          ? parseResponseText(err.responseText)
          : null
      const errorData = data ? data.msg : null

      yield put(
        errorExpiredExtendTrial({
          error: true,
          data: errorData || 'Server Error',
        })
      )
    }
  }
}

export const Test = {
  _getExpiredExtendTrial,
}

// Watchers
// ---------------------------------------------------------------------------
export function* watchGetExpiredExtendTrial(api, error) {
  yield takeEvery(EXPIRED_EXTEND_TRIAL_GET, _getExpiredExtendTrial(api, error))
}
